const DOZENT_THEME_STATIC_PATHS = new Set([
  "/login",
  "/passwort-vergessen",
  "/passwort-zuruecksetzen",
  "/datenschutz",
  "/datenschutz/success",
]);

export const DOZENT_THEME_STORAGE_KEY = "dozent-theme";
export const ADMIN_THEME_STORAGE_KEY = "admin-theme";

export type ThemeScopeId = "light-only" | "dozent" | "admin";

export type ThemeScope = {
  id: ThemeScopeId;
  forcedTheme: "light" | undefined;
  storageKey: string;
};

function normalizePathname(pathname: string): string {
  if (!pathname) return "/";
  if (pathname === "/") return pathname;
  return pathname.endsWith("/") ? pathname.slice(0, -1) : pathname;
}

export function isDozentThemeRoute(pathname: string): boolean {
  const normalizedPathname = normalizePathname(pathname);
  if (DOZENT_THEME_STATIC_PATHS.has(normalizedPathname)) {
    return true;
  }
  return normalizedPathname === "/dozent" || normalizedPathname.startsWith("/dozent/");
}

export function isAdminThemeRoute(pathname: string): boolean {
  const normalizedPathname = normalizePathname(pathname);

  if (normalizedPathname === "/admin/login") {
    return false;
  }

  return normalizedPathname === "/admin" || normalizedPathname.startsWith("/admin/");
}

export function resolveThemeScope(pathname: string): ThemeScope {
  if (isDozentThemeRoute(pathname)) {
    return {
      id: "dozent",
      forcedTheme: undefined,
      storageKey: DOZENT_THEME_STORAGE_KEY,
    };
  }

  if (isAdminThemeRoute(pathname)) {
    return {
      id: "admin",
      forcedTheme: undefined,
      storageKey: ADMIN_THEME_STORAGE_KEY,
    };
  }

  return {
    id: "light-only",
    forcedTheme: "light",
    storageKey: DOZENT_THEME_STORAGE_KEY,
  };
}

export function getForcedThemeForPathname(
  pathname: string,
): "light" | undefined {
  return resolveThemeScope(pathname).forcedTheme;
}
